import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MachineInfosService } from '@app/components/machine-infos/machine-infos.service';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-highlights-and-data',
    templateUrl: './highlights-and-data.component.html',
    styleUrls: ['./highlights-and-data.component.css'],
    imports: [TranslateModule]
})
export class HighlightsAndDataComponent implements OnInit {

    @Input() htmlstring: SafeHtml;
    @Input() mode: string;

    pos: number;
    title: string;

    constructor(
        private readonly machineinfos: MachineInfosService,
        private readonly router: Router
    ) { }

    ngOnInit() {

        this.mode = this.router.url.split('/').pop();

        if (!this.htmlstring) { // provided by parent
            switch (this.mode) {
                case 'technicaldata': {
                    this.machineinfos.specsheet$.subscribe(result => this.htmlstring = result);
                    break;
                }
                case 'highlights': {
                    this.pos = history.state.position ?? 0;
                    this.machineinfos.highlights$.subscribe(result => {
                        if (result) {
                            const parsed = JSON.parse(result)[this.pos];
                            this.title = parsed.BEZEICHNUNG;
                            this.htmlstring = parsed.TEXT1;
                        }
                    });

                    break;
                }
            }
        }
    }
}
